"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.webstore = exports.retry = exports.dummyPaymentMethods = exports.dummyPaymentMethod = exports.dummyAddress = void 0;
var debug_1 = __importDefault(require("debug"));
var fetcher_1 = __importDefault(require("./fetcher"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var debug = (0, debug_1.default)('nuts:ad:webstore');
exports.dummyAddress = {
    name: 'Nut Lover',
    street1: '10 Exchange Place',
    street2: 'Floor 28',
    city: 'Jersey City',
    stateProv: 'NJ',
    postalCode: '07302',
    countryCode: 'US',
    phone1: '8005586887',
    email: 'nuts@nuts.com',
};
exports.dummyPaymentMethod = {
    billingMethod: 'Visa',
    lastFourDigits: '4111',
    expiresOn: '2020-02-01',
    externalAccountToken: 'test@nuts.test',
};
exports.dummyPaymentMethods = [
    {
        user: { id: '123', commercetoolsCustomerId: 'abc' },
        paymentMethod: exports.dummyPaymentMethod,
    },
];
function extractErrorMessage(errorResponse) {
    var _a;
    return (_a = errorResponse.errors) === null || _a === void 0 ? void 0 : _a[0].message;
}
function makeOptions(options) {
    return __assign(__assign({ extractErrorMessage: extractErrorMessage }, exports.webstore.defaults), options);
}
function get(url, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, retry(function () { return fetcher_1.default.get(url, makeOptions(options)); }, {
                    onError: function (e) { return e.message === '504 GATEWAY_TIMEOUT'; },
                })];
        });
    });
}
function getPaymentMethod(customerId) {
    return __awaiter(this, void 0, void 0, function () {
        var paymentMethod;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, get('/api/auto-delivery/payment-method', {
                        params: {
                            customerId: customerId,
                        },
                    })];
                case 1:
                    paymentMethod = _a.sent();
                    if ((0, isEmpty_1.default)(paymentMethod)) {
                        throw new Error('empty payment method received');
                    }
                    return [2 /*return*/, paymentMethod]; // undefined will be caught by isEmpty
            }
        });
    });
}
function getPaymentMethods(params) {
    return __awaiter(this, void 0, void 0, function () {
        var paymentMethods;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, get('/api/auto-delivery/payment-methods', {
                        params: params,
                    })];
                case 1:
                    paymentMethods = _a.sent();
                    return [2 /*return*/, paymentMethods || []];
            }
        });
    });
}
function getShippingAddress(addressId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, get('/api/auto-delivery/shipping-address', {
                    params: {
                        addressId: addressId,
                    },
                })];
        });
    });
}
function getShippingAddresses(customerId, addressIds) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, get('/api/auto-delivery/shipping-addresses', {
                    params: {
                        customerId: customerId,
                        addressIds: addressIds,
                    },
                })];
        });
    });
}
function post(url, data, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetcher_1.default.post(url, data, makeOptions(options))];
        });
    });
}
function retry(fn, _a) {
    var _b = _a === void 0 ? {} : _a, onError = _b.onError, reset = _b.reset, _c = _b.retries, retries = _c === void 0 ? 3 : _c;
    return __awaiter(this, void 0, void 0, function () {
        var lastError, retriesLeft, error_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    retriesLeft = retries;
                    _d.label = 1;
                case 1:
                    if (!(retriesLeft >= 0)) return [3 /*break*/, 8];
                    if (!(retriesLeft !== retries)) return [3 /*break*/, 4];
                    return [4 /*yield*/, (onError === null || onError === void 0 ? void 0 : onError(lastError))];
                case 2:
                    if ((_d.sent()) === false) {
                        return [3 /*break*/, 8];
                    }
                    debug('retrying');
                    return [4 /*yield*/, (reset === null || reset === void 0 ? void 0 : reset(lastError))];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, fn()];
                case 5: return [2 /*return*/, _d.sent()];
                case 6:
                    error_1 = _d.sent();
                    lastError = error_1;
                    return [3 /*break*/, 7];
                case 7:
                    retriesLeft--;
                    return [3 /*break*/, 1];
                case 8: throw lastError;
            }
        });
    });
}
exports.retry = retry;
function submitOrder(order) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, post('/api/auto-delivery/orders', order)];
                case 1:
                    response = _a.sent();
                    if (!response) {
                        throw new Error('empty response after placing order');
                    }
                    return [2 /*return*/, response];
            }
        });
    });
}
exports.webstore = {
    defaults: {},
    getPaymentMethod: getPaymentMethod,
    getPaymentMethods: getPaymentMethods,
    getShippingAddress: getShippingAddress,
    getShippingAddresses: getShippingAddresses,
    get: get,
    post: post,
    submitOrder: submitOrder,
};
//# sourceMappingURL=webstore.js.map